import { render, staticRenderFns } from "./ReportMeal.vue?vue&type=template&id=15159dce&"
import script from "./ReportMeal.vue?vue&type=script&lang=js&"
export * from "./ReportMeal.vue?vue&type=script&lang=js&"
import style0 from "./ReportMeal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports